const selector = (availableAssets) => availableAssets.map((a) => a.assetName)

export default selector
